{
  "dashboard": {
    "hello": "Bonjour {{firstname}}",
    "title": "Tableau de bord",
    "openMissions": "Missions ouvertes",
    "pendingRequests": "Requêtes en attente",
    "deliveredRequests": "Requêtes délivrées",
    "companiesTitle": "Vos entreprises",
    "companiesSubtitle": "Gérez vos entreprises et suivez leurs missions",
    "partner": "Partenaire",
    "customer": "Client",
    "followedMissionsTitle": "Missions suivies",
    "followedMissionsSubtitle": "Suivez vos missions en temps réel",
    "requestsCount": "Nombre de requêtes",
    "manager": "Responsable",
    "noDocumentYet": "Pas encore de document déposé.",
    "documentsCount": "Nombre de documents",
    "lastDepositOn": "Dernier dépôt le",
    "noFollowedMissionTitle": "Aucune mission suivie trouvée",
    "noFollowedMissionText": "Vous n'avez pas encore suivi de mission.",
    "requestsTitle": "Requêtes",
    "requestsSubtitle": "Suivez vos requêtes qui expirent dans 2 jours",
    "expiresSoon": "Expire bientôt",
    "client": "Client",
    "mission": "Mission",
    "noRequestTitle": "Aucune requête trouvée",
    "noRequestText": "Vous n'avez pas de requête qui expire dans 2 jours.",
    "relaunchTitle": "Relances",
    "relaunchSubtitle": "Relances depuis 7 jours",
    "relaunchForMission": "Relance des requêtes pour la mission",
    "noRelaunchTitle": "Aucune relance trouvée",
    "noRelaunchText": "Vous n'avez pas de relance depuis 7 jours.",
    "helpTitle": "Aide et Support",
    "helpText": "Pour tous renseignements, veuillez contacter le support :",
    "error": "Une erreur s'est produite"
  },
  "help": {
    "title": "Aide",
    "text": "Pour tous renseignements, veuillez contacter le support technique :"
  },
  "common": {
    "error": "Une erreur s'est produite",
    "sortBy": "Trier par :",
    "back": "Retour",
    "backToDashboard": "Retour au tableau de bord",
    "service": "Service",
    "name": "Nom",
    "manager": "Responsable",
    "dueDate": "Date de fin",
    "id": "ID",
    "category": "Catégorie",
    "status": "Statut",
    "undefined": "Non défini",
    "undefinedFemale": "Non définie",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "actions": "Actions",
    "creator": "Créateur",
    "yes": "Oui",
    "no": "Non",
    "reset": "Reset"
  },
  "status": {
    "legend": "Statuts des requêtes :",
    "pending": "En attente",
    "late": "En retard",
    "delivered": "Délivré",
    "accepted": "Accepté",
    "column": "Statut des requêtes"
  },
  "customerHome": {
    "missionsTitle": "Missions",
    "missionsSubtitle": "Gérez vos missions et suivez leur progression",
    "noMissionTitle": "Aucune mission trouvée",
    "noMissionText": "Vous n'avez pas encore de missions en cours. Les missions apparaîtront ici une fois qu'elles seront créées."
  },
  "customerRequests": {
    "mission": "Mission",
    "dueDate": "Date de fin",
    "progress": "Progression :",
    "hideOld": "Masquer anciennes",
    "showOld": "Afficher anciennes",
    "creation": "Création",
    "date": "Date",
    "limit": "Limite",
    "description": "Description",
    "requester": "Demandeur",
    "docs": "Docs",
    "refused": "Requête refusée",
    "relaunched": "Requête relancé le {{date}} par {{user}}",
    "request": "Requête",
    "documents": "Documents",
    "details": "Détails",
    "chat": "Chat",
    "documentsList": "Liste des documents déposés :",
    "noDocuments": "Il n'y a aucun documents déposés",
    "uploadDate": "Date upload",
    "type": "Type",
    "documentDeleted": "Le document a bien été supprimé",
    "requestDetails": "Détails de la demande",
    "requestId": "ID Requête",
    "createdAt": "Date création",
    "state": "État",
    "noDescription": "Aucune description fournie",
    "discussion": "Discussion",
    "discussionSubtitle": "Échangez avec votre interlocuteur sur cette requête",
    "noMessageTitle": "Aucun message",
    "noMessageText": "Commencez la conversation en envoyant votre premier message",
    "messagePlaceholder": "Tapez votre message...",
    "newLineHint": "Shift + Entrée pour une nouvelle ligne",
    "send": "Envoyer"
  },
  "workingFolder": {
    "title": "ACCÈS DOSSIER DE TRAVAIL",
    "welcome": "Bienvenue sur Nexum !",
    "wantsToShare": "souhaiterait vous communiquer l'accès au dossier de travail dans le cadre de la mission :",
    "securityHint": "À des fins de sécurité, nous vous invitons à renseigner le mot de passe que vous avez reçu par mail.",
    "password": "Mot de passe",
    "validate": "Valider",
    "expiredTitle": "Accès expiré",
    "expiredText": "Cet accès a expiré, nous vous invitons à vous rapprocher de votre interlocuteur, évoqué dans le mail contenant ce lien.",
    "downloadSuccess": "Fichier téléchargé avec succès",
    "accessGranted": "Accès autorisé",
    "folderOf": "Voici le dossier travail de {{name}}",
    "downloading": "Téléchargement en cours...",
    "downloadFolder": "Télécharger le dossier",
    "wrongPassword": "Mot de passe incorrect",
    "downloadError": "Erreur lors du téléchargement"
  },
  "partner": {
    "fetchClientsError": "Erreur lors de la récupération des clients",
    "fetchDocumentsError": "Erreur lors de la récupération des documents",
    "customersTitle": "Vos dossiers clients",
    "customersSubtitle": "Gérez vos dossiers clients et suivez leurs missions",
    "missionsMonitoring": "Monitoring des missions",
    "monitoring": "Monitoring",
    "relaunch": "Relance",
    "createCustomer": "Créer un client",
    "customerName": "Nom du client",
    "missions": "Missions",
    "noCustomerTitle": "Aucun client trouvé",
    "noCustomerText": "Vous n'avez pas encore créé de dossier client.",
    "missionsTitle": "Missions",
    "missionsSubtitle": "Gérez vos missions et suivez leur progression",
    "createWorkingFolder": "Créer un dossier travail",
    "workingFolder": "Dossier de travail",
    "addMission": "Ajouter une mission",
    "archiveDate": "Date d'archivage",
    "noMissionText": "Vous n'avez pas encore créé de mission.",
    "renewSuccess": "Mission reconduite avec succès",
    "watchSuccess": "Mission suivie avec succès vous recevrez les notifications",
    "enableNotifs": "Activer les notifications",
    "disableNotifs": "Désactiver les notifications",
    "renew": "Reconduire",
    "edit": "Modifier",
    "archive": "Archiver",
    "unwatchSuccess": "Vous ne recevrez plus les notifications",
    "acceptRequests": "Vous devez accepter les requêtes",
    "usersAssigned": "Utilisateurs affectés avec succès",
    "selectStatus": "Veuillez selectionner un statut",
    "statusUpdateError": "Erreur lors de la mise à jour des statuts !",
    "requestsTitle": "Requêtes",
    "archived": "(Archivée)",
    "addRequest": "Ajouter une requête",
    "importModel": "Importer Modèle",
    "exportModel": "Exporter Modèle",
    "template": "Template",
    "multiAssign": "Affectation multiple",
    "editStatuses": "Editer les statuts",
    "importSuccess": "Importation réussie !",
    "importError": "Erreur lors de l'importation !",
    "statusUpdated": "Statuts mis à jour !",
    "refused": "Refusé",
    "message": "Message",
    "month": "Mois",
    "noRequestText": "Vous n'avez pas encore créé de requête pour cette mission.",
    "documentsTitle": "Documents de la mission",
    "documentsSubtitle": "Consultez et téléchargez les documents associés",
    "document": "Document",
    "requestId": "Id requête :",
    "documentName": "Nom du document",
    "depositedOn": "Déposé le",
    "by": "Par",
    "workingFolderTitle": "Dossier de travail",
    "addAccess": "Ajouter un accès",
    "add": "Ajouter",
    "deleteShort": "Suppr.",
    "filesAndDocuments": "Fichiers et documents",
    "dropFile": "Glissez et déposez un fichier ici",
    "orClick": "ou cliquez pour sélectionner un fichier",
    "file": "Fichier",
    "noFileUploaded": "Aucun fichier n'a été téléchargé",
    "deleteFile": "Supprimer le fichier",
    "sendAccessHint": "En cliquant sur \"Envoyer\", un email sera envoyé à chaque utilisateur de ce dossier de travail pour leur donner accès au fichier.",
    "sendAccess": "Envoyer l'accès",
    "usersWithAccess": "Utilisateurs avec accès",
    "user": "Utilisateur",
    "sendDate": "Date envoi",
    "downloaded": "Téléchargé",
    "downloadDate": "Date téléchargement",
    "availableCollabs": "Collaborateurs disponibles",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Email",
    "assignment": "Assignation",
    "resendAccess": "Renvoyer l'accès",
    "revokeAccess": "Révoquer l'accès",
    "monitoringTitle": "Monitoring des requêtes",
    "missionManager": "Responsable de la mission",
    "requestStates": "États des requêtes",
    "rejectionRate": "Taux de rejet",
    "upcomingRequests": "Requêtes à venir",
    "deliveryTimes": "Délais d'envoi",
    "acceptanceTimes": "Délais d'acceptation",
    "averageDays": "Nombre de jours moyens",
    "days": "jours",
    "missionsMonitoringTitle": "Monitoring des missions",
    "missionsMonitoringSubtitle": "Suivez l'avancement de vos missions en temps réel",
    "customerFiles": "Dossiers clients",
    "filtersAndSort": "Filtres et tri",
    "progress": "Progression",
    "urgency": "Urgence",
    "allManagers": "Tous les responsables",
    "allCategories": "Toutes les catégories",
    "missionEnd": "Fin de mission",
    "noRequestForMission": "Aucune requête pour cette mission",
    "recoveryTitle": "Relances et informations des requêtes",
    "recoveryHint": "Depuis cette page, vous pouvez relancer les requêtes en retard ou informer les requêtes en attente, cette action enverra un mail a tous les utilisateurs assignés à la requête.",
    "overdueRequests": "Requêtes hors délais",
    "pendingRequests": "Requêtes en attente",
    "overdueCount": "{{count}} requête(s) en retard",
    "inProgressCount": "{{count}} requête(s) en cours",
    "relaunchRequests": "Relancer les requêtes",
    "informRequests": "Informer des requêtes",
    "overdueDays": "Jours de retard",
    "waitingDays": "Jours d'attente",
    "informedOn": "Informer le {{date}} par {{user}}"
  }
}
